/* AFIQ redesign · Film Room (/pages/film-room): click-to-load video facade, Skool click tracking, band price tokens.
   Loaded with defer by sections/afiq-filmroom-main + afiq-filmroom-band (guarded, runs once), after afiq-shop.js. */
(function () {
  'use strict';
  if (window.__afiqFilmInit || !window.AFIQ_UI) return;
  window.__afiqFilmInit = true;
  /* Price/tier tokens, filled from live AFIQ data (never hard-coded). Same helper in afiq-contact/faq/filmroom/quiz/reviews.js. */
  function afiqFill(html) {
    var U = window.AFIQ_UI, A = window.AFIQ, P = U.P, $ = U.$, L = A.LADDER || [];
    var vols = U.VOLS, e = U.priceDecks(vols), top = L[L.length - 1] || { min: 0, pct: 0 };
    var cards = vols.reduce(function (s, id) { return s + (+P[id].cards || 54); }, 0);
    var ladder = function (unit) {
      return L.map(function (t, i) {
        var nx = L[i + 1], label = !nx ? t.min + ' or more' : (nx.min - 1 > t.min ? t.min + '–' + (nx.min - 1) + ' decks' : t.min + ' decks');
        var price = unit ? ' (' + $(A.unitCents(t.min)) + (i === 0 ? ' each' : '') + ')' : '';
        return label + ' ' + t.pct + '%' + (i === 0 ? ' off' : '') + price;
      }).join(', ');
    };
    var map = {
      elite_total: $(e.total), elite_full: $(e.full), elite_save: $(e.save), elite_cards: String(cards),
      ladder: ladder(true), ladder_short: ladder(false),
      top_min: String(top.min), top_pct: String(top.pct), top_unit: $(A.unitCents(top.min)),
      volumes: vols.map(function (d) { return '<b>' + U.esc(P[d].label) + ': ' + U.esc(P[d].title) + '</b>: ' + U.esc(P[d].hook); }).join('<br>'),
      fl5_hook: P.fl5 ? U.esc(P.fl5.hook) : ''
    };
    return String(html)
      .replace(/\{basics_discounted:([^|}]*)\|([^}]*)\}/g, function (m, yes, no) { return U.basicsDiscounted ? yes : no; })
      .replace(/\{pct_(\d+)\}/g, function (m, n) { return String(A.tier(+n).pct); })
      .replace(/\{unit_(\d+)\}/g, function (m, n) { return $(A.unitCents(+n)); })
      .replace(/\{([a-z0-9_]+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }
  function afiqFillAll(root) {
    root = root || document;
    root.querySelectorAll('[data-afiq-tpl]').forEach(function (el) { el.innerHTML = afiqFill(el.getAttribute('data-afiq-tpl')); });
    root.querySelectorAll('[data-afiq-fill]').forEach(function (el) { el.innerHTML = afiqFill(el.innerHTML); });
  }

  afiqFillAll();
  var root = document.querySelector('[data-afiq-film]');
  if (!root) return;
  var track = window.AFIQ_UI.track;

  /* No YouTube iframe (or cookies) until the visitor presses play. */
  var frame = root.querySelector('[data-vsl]'), play = root.querySelector('[data-vsl-play]');
  if (frame && play) play.addEventListener('click', function () {
    var id = frame.getAttribute('data-video'), start = parseInt(frame.getAttribute('data-start'), 10) || 0;
    if (!id) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?start=' + start + '&autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.title = frame.getAttribute('data-title') || 'Film Room video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.setAttribute('allowfullscreen', '');
    frame.innerHTML = ''; frame.appendChild(f);
    track('afiq_vsl_play', { video_id: id, start: start, page: 'film_room' });
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-skool]');
    if (a) track('afiq_skool_click', { location: a.getAttribute('data-skool'), url: a.href, page: 'film_room' });
  });
})();
